import { render, staticRenderFns } from "./look-and-feel.vue?vue&type=template&id=0a13e3c3&"
import script from "./look-and-feel.vue?vue&type=script&lang=js&"
export * from "./look-and-feel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports